import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";

const EditAddForm = ({
  onHide,
  editable,
  setRes,
  rowData,
  setShowDialog,
  getKiosksData,
}) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      setLoading(true);
      try {

        const response = await axiosApi.get(
          `/Portal/transactions/get-all`
        );
        setHistory(response.data.body);
      } catch (error) {
        toast.error("Failed to fetch roles data.");
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  const status = [
    { label: "Pending", value: "pending" },
    { label: "Resolved", value: "Resolved" },
    { label: "OnHold", value: "OnHold" },
  ];
  const validationSchema = Yup.object({
    transactionHistoryId: Yup.string().required("select transaction History."),
    transactionId: Yup.string().required("transaction is required."),
    customerName: Yup.string().required("Customer Name is required."),
    customerMobileNumber:  Yup.string()
          .required("Mobile Number is required.")
          .matches(
            /^03\d{9}$/,
            "Mobile Number must start with 03 and be 11 digits long."
          )
          .length(11, "Mobile Number must be 11 digits long."),
    issueType: Yup.string().required("Issue Type is required."),
    description: Yup.string().required("Description is required."),
    status: Yup.string().required("Please select status."),

  });

  // console.log(rowData);

  const formik = useFormik({
    initialValues: {
      transactionHistoryId: rowData?.transactionHistoryId || "",
      transactionId: rowData?.transactionId || "",
      status: rowData?.status || "",
      customerName: rowData?.customerName || "",
      customerMobileNumber: rowData?.customerMobileNumber || "",
      issueType: rowData?.issueType || "",
      description: rowData?.description || "",


    },
    validationSchema,
    onSubmit: async (data) => {
      setLoading(true);
      try {
        let response;
        data.id = rowData?.id;
        if (editable) {
          data.id = rowData.id;
          response = await axiosApi.put("/Portal/users/edit", data);
        } else {
          response = await axiosApi.post("/Portal/csr/add", data);
        }

        console.log("API Response:", response.data);

        if (response.data.responseCode === "200") {
          toast.success(response.data?.responseDescription || "Operation Successful!");
        } else {
          toast.error(
            response.data?.responseDescription || "Something went wrong!"
          );
        }
        setRes(response);
        setShowDialog(false);
      } catch (error) {
        // Only show error if an actual exception occurs
        console.error("API Error:", error);
        toast.error(
          error.response?.data?.message ||
          "An unexpected error occurred. Please try again."
        );
      } finally {
        setLoading(false);
      }

    }

  });
  return (
    <div className="main-form">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-6">
            <label htmlFor="companyName">
              Transaction History<span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="transactionHistoryId"
              name="transactionHistoryId"
              value={formik.values.transactionHistoryId}
              onChange={formik.handleChange}
              options={history.map((history) => ({
                label: history.transactionId,
                value: history.id,
              }))}
              placeholder="Select User"
            />
            {formik.touched.transactionHistoryId && formik.errors.transactionHistoryId && (
              <small className="p-error">{formik.errors.transactionHistoryId}</small>
            )}
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Customer Name <span className="text-danger"> *</span>
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              id="customerName"
              name="customerName"
              maxLength={"30"}
              value={formik.values.customerName}
              placeholder="Enter Customer Name"
              onChange={formik.handleChange}
            />
            {formik.touched.customerName && formik.errors.customerName && (
              <small className="p-error">{formik.errors.customerName}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Transaction Id <span className="text-danger"> *</span>
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              placeholder="Enter Transaction Id"
              // maxLength={"20"}
              id="transactionId"
              name="transactionId"
              value={formik.values.transactionId}
              onChange={formik.handleChange}
            />
            {formik.touched.transactionId && formik.errors.transactionId && (
              <small className="p-error">{formik.errors.transactionId}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Customer Mobile Number <span className="text-danger"> *</span>
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              id="customerMobileNumber"
              name="customerMobileNumber"
              maxLength={"11"}
              value={formik.values.customerMobileNumber}
              placeholder="Enter customer Mobile Number"
              onChange={formik.handleChange}
            />
            {formik.touched.customerMobileNumber && formik.errors.customerMobileNumber && (
              <small className="p-error">{formik.errors.customerMobileNumber}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Issue Type <span className="text-danger"> *</span>
            </label>
            <InputText
             
              id="issueType"
              name="issueType"
              maxLength={"30"}
              value={formik.values.issueType}
              placeholder="Enter Customer Name"
              onChange={formik.handleChange}
            />
            {formik.touched.issueType && formik.errors.issueType && (
              <small className="p-error">{formik.errors.issueType}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Description <span className="text-danger"> *</span>
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              placeholder="Enter Description"
              maxLength={"20"}
              id="description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
            />
            {formik.touched.description && formik.errors.description && (
              <small className="p-error">{formik.errors.description}</small>
            )}
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="companyName">
              Status <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="status"
              name="status"
              value={formik.values.status}
              onChange={formik.handleChange}
              options={status}
              placeholder="Select Status "
            />
            {formik.touched.status && formik.errors.status && (
              <small className="p-error">{formik.errors.status}</small>
            )}
          </div>



        </div>

        <div className="form-buttons mt-4">
          <ActionButtons
            loading={loading}
            onCancel={onHide}
            onSave={formik.handleSubmit}
            saveLabel={editable ? "Update Changes" : "Save Changes"}
            showSave={true}
            cancelLabel="Cancel"
          />
        </div>
      </form>
    </div>
  );
};

export default EditAddForm;
